export default "__VITE_PUBLIC_ASSET__ffc14672__"